import { render, staticRenderFns } from "./ClientScreenProjects.vue?vue&type=template&id=53babbf8&scoped=true"
import script from "./ClientScreenProjects.vue?vue&type=script&lang=ts"
export * from "./ClientScreenProjects.vue?vue&type=script&lang=ts"
import style0 from "./ClientScreenProjects.vue?vue&type=style&index=0&id=53babbf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53babbf8",
  null
  
)

export default component.exports